module.exports = __webpack_public_path__ + "static/media/i-tree_design-logo.e4e9f660.png";